import moment from 'moment';
import style from './style.module.scss';
import { Dropdown } from 'antd';
import BottomChevron from 'assets/images/navigation/ic-chevron-down-blue.svg';

export const offerType = {
  10: 'Per Meter',
  // 10: 'Percentage',
  20: 'Absolute',
};

export const offerTypeReverse = {
  PERMETER: 10,
  // PERCENTAGE: 10,
  ABSOLUTE: 20,
};

export const offer_type_options = [
  { name: 'Per Meter', id: offerTypeReverse.PERMETER },
  // { name: 'Percentage', id: offerTypeReverse.PERCENTAGE },
  { name: 'Absolute', id: offerTypeReverse.ABSOLUTE },
];

export const COUPON_STATUS = {
  10: 'Active',
  20: 'Deactivated',
  30: 'Expired',
};

export const COUPON_STATUS_REVERSE = {
  ACTIVE: 10,
  DEACTIVATED: 20,
};

export const CATEGORY_TYPES = {
  1: 'Cotton',
  2: 'Rayon',
  3: 'Denim',
};

export const categoryOptions = [
  { id: 1, name: 'Cotton' },
  { id: 2, name: 'Rayon' },
  { id: 3, name: 'Denim' },
];

export const REQUIREMENT_TYPE = {
  10: 'Greige',
  20: 'Processing (Finished Fabric)',
};

export const requirementTypeOptions = [
  { id: 10, name: 'Greige' },
  { id: 20, name: 'Processing (Finished Fabric)' },
];

export const APPLICABLE_FOR_TYPE = {
  10: 'Cash',
  20: 'Credit',
};

export const ApplicableForOptions = [
  { id: 10, name: 'Cash' },
  { id: 20, name: 'Credit' },
];

export const DELIVERY_TYPE = {
  1: 'Landed',
  2: 'x-factory',
};

export const deliveryTypeOptions = [
  { id: 1, name: 'Landed' },
  { id: 2, name: 'x-factory' },
];

export const columnsData = (onMenuClick) => [
  {
    title: 'Name',
    dataIndex: 'couponName',
    render: (value) => {
      return <div>{value}</div>;
    },
  },
  {
    title: 'Code',
    dataIndex: 'couponCode',
    render: (value) => {
      return <div>{value}</div>;
    },
  },
  {
    title: 'Offer type',
    dataIndex: 'offerType',
    render: (value) => {
      return <div>{offerType[value]}</div>;
    },
  },
  {
    title: 'Amount',
    dataIndex: 'discountAmount',
    render: (value, record) => {
      const isPerMeter = record?.offerType === offerTypeReverse.PERMETER;

      return (
        <div>
          ₹ {value}
          {isPerMeter ? ' /m' : ''}
        </div>
      );
    },
  },
  {
    title: 'Active from',
    dataIndex: 'startDate',
    render: (value) => {
      return <div>{moment(value).format('DD/MM/YYYY')}</div>;
    },
  },
  {
    title: 'Active to',
    dataIndex: 'endDate',
    render: (value) => {
      return <div>{moment(value).format('DD/MM/YYYY')}</div>;
    },
  },

  {
    title: 'Max usage',
    dataIndex: 'maxUsagePerUser',
    render: (value) => {
      return <div>{value}</div>;
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (value, record) => {
      const isExpired = moment.utc(record.endDate).isBefore(moment.utc());
      if (isExpired && record.status !== COUPON_STATUS_REVERSE.DEACTIVATED)
        return <p className={style['status-expired']}>Expired</p>;

      switch (value) {
        case COUPON_STATUS_REVERSE.ACTIVE:
          return <p className={style['status-active']}>{COUPON_STATUS[value]}</p>;
        case COUPON_STATUS_REVERSE.DEACTIVATED:
          return <p className={style['status-deactivated']}>{COUPON_STATUS[value]}</p>;
      }
    },
  },
  {
    title: 'Action',
    dataIndex: 'action',
    fixed: 'right',
    width: 100,
    render: (_, record) => {
      const isExpired = moment.utc(record.endDate).isBefore(moment.utc());
      const disabled = record.status !== COUPON_STATUS_REVERSE.ACTIVE || isExpired;
      const actionMenuOptions = [
        { key: 1, label: 'View Details' },
        { key: 2, label: 'Deactivate', hidden: disabled },
      ];

      return (
        <Dropdown
          overlayClassName={style.customDropdown}
          menu={{
            items: actionMenuOptions,
            onClick: ({ key }) => onMenuClick(key, record),
          }}
          trigger={['click']}>
          <span className={style.dropdownTrigger}>
            Action
            <img src={BottomChevron} alt="chevron icon" className={style.chevronIcon} />
          </span>
        </Dropdown>
      );
    },
  },
];

export const initialValues = {
  couponName: '',
  couponCode: '',
  offerType: '',
  discountAmount: '',
  discountPercentage: '',
  maxUsagePerUser: '',
  startDate: '',
  endDate: '',
  minQuantity: '',
  minMargin: '',
  isForNewCustomers: false,
  isVisible: false,
  minOrderValue: '',
  customerSheet: null,
  category: [],
  requirementType: [],
  applicableFor: [],
  deliveryType: [],
  status: true,
};
